import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'

interface UseRenameReviewAnalysisFacilityMutationParams {
  onError?: () => void
  onSuccess?: () => void
}

export const useRenameReviewAnalysisFacilityMutation = (
  campaignId: string,
  { onError, onSuccess }: UseRenameReviewAnalysisFacilityMutationParams = {}
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      facilityId,
      ...changes
    }: {
      category?: string | null
      facilityId: string
      name?: string
    }) =>
      ReviewAnalysisApiService.renameFacility(campaignId, facilityId, changes),
    onError: () => {
      onError?.()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_FACILITY_OVERVIEW, campaignId],
      })
      onSuccess?.()
    },
  })
}
